import React from 'react';
import './styles/Sumate.css';
import { Container } from 'react-bootstrap';
import mundo from '../archivos/mapa.gif';
import './styles/Sumate.css';
// import forma2 from '../archivos/forma2.png'
import { withTranslation } from 'react-i18next';
import FormContact from './FormContact';

class Sumate extends React.Component {
	constructor() {
		super();
		this.state = {
			info: [],
		};
	}

	render() {
		const { t, i18n } = this.props;
		return (
			<Container id='Sumate' className='containSumate'>
				<section className='seccionimg leftx2'>
					<img src={mundo} width='90%' height='auto' alt='Gif de trayectos por el mundo' />
				</section>
				<section className='seccion3 right'>
					<h1 className='titulo1'>{t('Sumate.titulo1')}</h1>
					<h3 className='tituloh4'>{t('Sumate.tituloh4')}</h3>
					<p>{t('Sumate.pe')}</p>

					<p>
						<span style={{ fontWeight: 'bold' }}>{t('Sumate.pe2.1')}</span>
						<br></br>
						{t('Sumate.pe2.2')}
					</p>
				</section>
				<FormContact />
				{/* <section className="sumate">
                    <h1 className="tituloIt">{t('Sumate.titulo.it')}</h1>
                    <h3 className="tituloh4">{t('Sumate.tituloh4.2')}</h3>
                    <p className="pa">
                        {t('Sumate.pa')}
                    </p>
                    <p className="pa">
                        {t('Sumate.pa.CV')} <span className="pa-email">empleos@jedify.io</span>
                    </p>
                </section>
                <section className="sboton1" >
                    <a href="mailto:empleos@jedify.io" className="boton1">{t('Sumate.cv')}</a>
                </section> */}
				{/* <section className="absol3">
                    <img src={forma2}
                        width="100%"
                        height="auto"
                        alt="np"

                    />
                </section> */}
			</Container>
		);
	}
}
export default withTranslation()(Sumate);
